import ShortDate from "./ShortDate";

function ShortDateRange({ date1, date2 }) {
  const d1 = ShortDate({ date: date1 });
  const d2 = ShortDate({ date: date2 });

  let year = "";
  if (d1.length > 6 || d2.length > 6) {
    if (d1.substring(d1.length - 4) === d2.substring(d2.length - 4)) {
      year = d1.substring(d1.length - 6);
    } else {
      return `${d1} - ${d2}`;
    }
  }

  // if (d1.substring(3, 6) === d2.substring(3, 6)) {
  //   return `${d1.substring(0, 2)}-${d2.substring(0, 2)} ${d1.substring(
  //     3,
  //     6
  //   )}${year}`;
  // }
  return `${d1.substring(0, 6)}-${d2.substring(0, 6)}${year}`;
}

export default ShortDateRange;
